import { render, staticRenderFns } from "./TrendChart.vue?vue&type=template&id=72d89316&"
import script from "./TrendChart.vue?vue&type=script&lang=ts&"
export * from "./TrendChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports